<template>
    <div id="subtest-form">
        <v-card flat class="my-3">
            <!-- Tryout Subtest Items -->
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Durasi (Menit)
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        <v-text-field
                            id="tryout-subtest-form-duration"
                            type="number"
                            placeholder="(menit)"
                            suffix="menit"
                            v-model="subtest.duration"
                            step="0.5"
                            outlined
                        />
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        KKM
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        <v-text-field
                            type="number"
                            placeholder="Isi KKM"
                            v-model="subtest.kkm"
                            outlined
                        />
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Mata Pelajaran *
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        <app-choosemapel
                            id="tryout-subtest-form-mapel"
                            v-on:selected="mapelSelected($event)"
                            v-if="$store.state.tryout.status"
                        ></app-choosemapel>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-card-text class="ma-0 pa-0">
                <v-card outlined class="ma-0 pa-0">
                    <v-card-text>
                        <v-list-item two-line class="pa-0">
                            <v-list-item-content class="pa-0">
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Perakitan Test *
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    Rakit test dengan mencari bab atau soal
                                    melalui tombol dibawah</v-list-item-subtitle
                                >
                            </v-list-item-content>
                        </v-list-item>
                        <!-- Perakitan test component used keyAssembler to make value change shown -->
                        <app-assemblesubtest
                            id="tryout-subtest-form-perakitan"
                            :pdisabled="subject"
                            :subject="subject"
                            :key="keyAssembler"
                            v-on:updated="detailsUpdated($event)"
                        ></app-assemblesubtest>
                    </v-card-text>
                </v-card>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    id="tryout-subtest-back-btn"
                    depressed
                    text
                    @click="$emit('back')"
                >
                    Kembali
                </v-btn>
                <v-btn
                    color="blew"
                    id="tryout-subtest-save-btn"
                    depressed
                    @click="save()"
                    dark
                >
                    Simpan
                </v-btn>
            </v-card-actions>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AssembleSubTest from "@/modules/tryout/components/AssembleSubTest";
import ChooseMapel from "@/modules/tryout/components/ChooseMapel";
import Spinner from "@/modules/global/components/plugins/Spinner";
import TryoutService from "@/modules/tryout/services/tryout.js";

export default {
    name: "subtest-form",

    components: {
        "app-assemblesubtest": AssembleSubTest,
        "app-choosemapel": ChooseMapel,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            subtest: {
                id: 0,
                tryout_id: 0,
                subject_code: "",
                subject_name: "",
                subject_picture: "",
                duration: 0,
                item_count: 0,
                details: [],
                kkm: 0,
            },
            keyAssembler: 0,
            subject: null,
            isLoading: false,
        };
    },

    watch: {
        subject() {
            this.keyAssembler++;
        },
    },

    methods: {
        // get detail data mapel
        mapelSelected: function (data) {
            this.subject = data;
            this.subtest.subject_code = this.subject.code;
            this.subtest.subject_name = this.subject.nama;
            this.subtest.subject_picture = this.subject.picture;
        },

        // if Perakitan test value change, put in this.subtest.details
        detailsUpdated: function (data) {
            this.subtest.tryout_id = this.$store.state.tryout.id;
            this.subtest.details = data;
            this.subtest.item_count = data.length;
        },

        // save subtest
        save: function () {
            this.isLoading = true;
            var context = this;

            if (this.subtest.id != 0) {
                TryoutService.updateSubtest(this.subtest, function (result) {
                    context.isLoading = false;
                    if (result.success) {
                        context.$store.commit(
                            "tryout_edit_subtest",
                            result.data,
                        );
                        context.$emit("completed");
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Data tidak lengkap!`,
                            submessage: `Silahkan lengkapi data terlebih dahulu!`,
                            type: "error",
                        });
                    }
                });
            } else {
                TryoutService.saveSubtest(this.subtest, function (result) {
                    context.isLoading = false;
                    if (result.success) {
                        context.$store.commit(
                            "tryout_add_subtest",
                            result.data,
                        );
                        context.$emit("completed");
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Data tidak lengkap!`,
                            submessage: `Silahkan lengkapi data terlebih dahulu!`,
                            type: "error",
                        });
                    }
                });
            }
        },
    },

    mounted: function () {
        // get detail data subtest
        if (this.$store.getters.selectedSubtest) {
            this.subtest = this.$store.getters.selectedSubtest;
            this.subject = {
                nama: this.subtest.subject_name,
                code: this.subtest.subject_code,
                picture: this.subtest.subject_picture,
            };
        }
    },
};
</script>



// WEBPACK FOOTER //
// SubtestForm.vue?1727e57e